import { render, staticRenderFns } from "./orderDetail_2.vue?vue&type=template&id=315faef8&scoped=true&"
import script from "./orderDetail_2.vue?vue&type=script&lang=js&"
export * from "./orderDetail_2.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail_2.vue?vue&type=style&index=0&id=315faef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315faef8",
  null
  
)

export default component.exports